import ImportImages from '@src/importImages';

// Napa
const NapaHotAir = ImportImages(
  '/experiences/Napa/napa_hot_air_balloon_summer_napa_valley_images_courtesy_of_Bob_McClenahan_small.jpg'
);
const Auberge = ImportImages('/experiences/Napa/auberge.jpg');
const Ballon = ImportImages('/experiences/Napa/hotairballoon.jpg');
const Bardessono = ImportImages('/experiences/Napa/bardessono.jpg');
const CookingNapa = ImportImages('/experiences/Napa/cooking.jpg');
const Croquet = ImportImages('/experiences/Napa/croquet.jpg');
const JellyBelly = ImportImages('/experiences/Napa/jellybelly-1.jpg');
const Meadowood = ImportImages('/experiences/Napa/meadowood.jpg');
const Racing = ImportImages('/experiences/Napa/racingschool.jpg');
const SingleThread = ImportImages('/experiences/Napa/singlethread.jpg');
const Yoga = ImportImages('/experiences/Napa/yoga.jpg');
const Carneros = ImportImages('/experiences/Napa/carneros.jpg');
const Welcome = ImportImages('/experiences/Napa/napa-welcome.jpg');

// Aspen
//const Rodeo = ImportImages('/experiences/Aspen/rodeo.jpg');
/*const Jeep = ImportImages('/experiences/Aspen/jeep.jpg');
const MineTour = ImportImages('/experiences/Aspen/minetour.jpg');
const Hike = ImportImages('/experiences/Aspen/hike.jpg');*/
const Jerome = ImportImages('/experiences/Aspen/jerome.jpg');
const LittleNell = ImportImages('/experiences/Aspen/littlenell.jpg');
const AspenMain = ImportImages('/experiences/Aspen/landing.jpg');
const AspenWelcome = ImportImages('/experiences/Aspen/aspen-welcome.jpg');
const StRegis = ImportImages('/experiences/Aspen/st-regis.jpg');
const Dog = ImportImages('/experiences/Aspen/dog-sledding-adventure.jpg');
const HikeMarron = ImportImages('/experiences/Aspen/hike-marron-bells.jpg');
const SkiInstruction = ImportImages('/experiences/Aspen/private-ski-instruction.jpg');
const Snowmobile = ImportImages('/experiences/Aspen/snowmobile-tour.jpg');
const WoodCreekBike = ImportImages('/experiences/Aspen/woody-creek-bike.jpg');

// Dallas
const DallasWelcome = ImportImages('/experiences/Dallas/landing.jpeg');
const WhyDallas = ImportImages('/experiences/Dallas/why-dallas.jpeg');
const ArtTour = ImportImages('/experiences/Dallas/dallas-art-tour.jpg');
const CowboysStadiun = ImportImages('/experiences/Dallas/dallas-cowboys-AT_T-stadium.jpg');
const DayTour = ImportImages('/experiences/Dallas/daytour-dallas.jpg');
const FourSeasonDallas = ImportImages('/experiences/Dallas/four-seasons-resort-and-club.jpg');
const PerotMuseum = ImportImages('/experiences/Dallas/perot-museum-of-nature.jpg');
const RosewoodMansion = ImportImages('/experiences/Dallas/rosewood-mansion.jpg');
const SouthforkRanch = ImportImages('/experiences/Dallas/southfork-ranch.jpg');
const JouleDallas = ImportImages('/experiences/Dallas/the-joule-dallas.jpg');

// Denver
const DenverWelcome = ImportImages('/experiences/Denver/landing.jpg');
const WhyDenver = ImportImages('/experiences/Denver/why-denver.jpg');
const BeerCompany = ImportImages('/experiences/Denver/denver-beer-company.jpg');
const FourSeasonsDenver = ImportImages('/experiences/Denver/four-seasons-denver.jpg');
const HikingColorado = ImportImages('/experiences/Denver/hiking-colorado.jpg');
const RcTent = ImportImages('/experiences/Denver/rc-tent.jpg');
const RockyMountain = ImportImages('/experiences/Denver/rocky-mountain-national-park.jpg');
const SupercarExp = ImportImages('/experiences/Denver/supercar-exp.jpg');

// Nashville
const NashvilleWelcome = ImportImages('/experiences/Nashville/landing.jpeg');
const WhyNashville = ImportImages('/experiences/Nashville/why-nashville.jpeg');
const BbqBeer = ImportImages('/experiences/Nashville/bbq-beer-tour.jpg');
const CookingClass = ImportImages('/experiences/Nashville/cooking-class.jpg');
const HermitageHotel = ImportImages('/experiences/Nashville/hermitage-hotel.jpg');
const HistoricTour = ImportImages('/experiences/Nashville/historic-tour.jpg');
const HuttonHotel = ImportImages('/experiences/Nashville/huttonhotel.jpg');
const NoelleNashville = ImportImages('/experiences/Nashville/noelle-nashville.jpg');
const OldOpry = ImportImages('/experiences/Nashville/old-opry.jpg');
const RecordingStudio = ImportImages('/experiences/Nashville/recording-studio.jpg');
const ThompsonNashville = ImportImages('/experiences/Nashville/thompson-nashville.jpg');

//San Diego
const SanDiegoWelcome = ImportImages('/experiences/SanDiego/landing.jpg');
const WhySanDiego = ImportImages('/experiences/SanDiego/why-san-diego.jpg');
const DowntownSan = ImportImages('/experiences/SanDiego/downtown-san-diego.jpg');
const FairmontGrand = ImportImages('/experiences/SanDiego/fairmont-grand-del-mar-clubhouse.jpg');
const Giraffes = ImportImages('/experiences/SanDiego/giraffes-at-san-diego-zoo.jpg');
const PendrySanDiego = ImportImages('/experiences/SanDiego/pendry-san-diego.jpg');
const SilhouetteNaval = ImportImages('/experiences/SanDiego/silhouette-US-navy-naval-base.jpg');
const LodgeAtTorrey = ImportImages('/experiences/SanDiego/the-lodge-at-torrey-pines-la-jolla.jpg');
const WhaleWatching = ImportImages('/experiences/SanDiego/whale-watching.jpg');
const WineTourSanDiego = ImportImages('/experiences/SanDiego/wine-tour.jpg');

// Scottsdale
const ScottsdaleWelcome = ImportImages('/experiences/Scottsdale/landing.jpg');
const WhyScottsdale = ImportImages('/experiences/Scottsdale/why-scottsdale.jpg');
const CanyonSuites = ImportImages('/experiences/Scottsdale/canyon-suites-at-the-phonecian.jpg');
const CowboyExp = ImportImages('/experiences/Scottsdale/cowboy-exp.jpg');
const DesertBiking = ImportImages('/experiences/Scottsdale/desert-biking.jpg');
const DesertHiking = ImportImages('/experiences/Scottsdale/desert-hiking.jpg');
const FourseasonsScottsdale = ImportImages('/experiences/Scottsdale/fourseasons-scottsdale.jpg');
const FrankLloyd = ImportImages('/experiences/Scottsdale/frank-lloyd.jpg');
const KayakingTour = ImportImages('/experiences/Scottsdale/kayaking-tour.jpg');
const SanctuaryCamel = ImportImages('/experiences/Scottsdale/sanctuary-on-camelback.jpg');


// DC
const DCWelcome = ImportImages('/experiences/DC/landing-dc1.jpg');
const WhyDC = ImportImages('/experiences/DC/why-dc.jpg');
const AtNightDC = ImportImages('/experiences/DC/at-night-dc.jpg');
const CivilWar = ImportImages('/experiences/DC/civil-war.jpg');
const FourseasonsDC = ImportImages('/experiences/DC/fourseasons-dc.jpg');
const HayAdams = ImportImages('/experiences/DC/hay-adams-dc.jpg');
const Mandarin = ImportImages('/experiences/DC/mandarin-dc.jpg');
const RosewoodDC = ImportImages('/experiences/DC/rosewood-dc.jpg');
const WhiteHouse = ImportImages('/experiences/DC/whitehouse.jpg');

// Charleston
const Cooking = ImportImages('/experiences/Charleston/cooking.jpg');
const Charleston = ImportImages('/experiences/Charleston/charleston.jpg');
const Garden = ImportImages('/experiences/Charleston/garden.jpg');
const Golf = ImportImages('/experiences/Charleston/golf.jpg');
const Plantation = ImportImages('/experiences/Charleston/plantation.jpg');
const Sailing = ImportImages('/experiences/Charleston/sailing.jpg');
const Dewberry = ImportImages('/experiences/Charleston/dewberry.jpg');
const ZeroGeorge = ImportImages('/experiences/Charleston/ZeroGeorge_Final.jpg');
const CharlestonMain = ImportImages(
  '/experiences/Charleston/charleston-background.jpg'
);
const CharlestonWelcome = ImportImages(
  '/experiences/Charleston/charleston-welcome.jpg'
);
const WentWorth = ImportImages('/experiences/Charleston/wentworth.jpg');

// Miami
const Acqualina = ImportImages('/experiences/Miami/acqualina.jpg');
const Harbour = ImportImages('/experiences/Miami/harbour.jpg');
const Setai = ImportImages('/experiences/Miami/setai.jpg');
const Faena = ImportImages('/experiences/Miami/faena.jpg');
const Cheefs = ImportImages('/experiences/Miami/cheefs.jpg');
const Lobby = ImportImages('/experiences/Miami/lobby.jpg');
const SeaPlane = ImportImages('/experiences/Miami/seaplane.jpg');
const SwampTour = ImportImages('/experiences/Miami/swamptour.jpg');
const VipTable = ImportImages('/experiences/Miami/vip-table.jpg');
const MiamiMain = ImportImages('/experiences/Miami/miami-background.jpg');
const MiamiWelcome = ImportImages('/experiences/Miami/miami-welcome.jpg');

// Toronto
const ChineTown = ImportImages('/experiences/Toronto/chinetown.jpg');
const CnTower = ImportImages('/experiences/Toronto/cntower.jpeg');
const HallOfFame = ImportImages('/experiences/Toronto/halloffame.jpg');
const KingWest = ImportImages('/experiences/Toronto/kingwest.jpg');
const FourSeasons = ImportImages('/experiences/Toronto/fourseasons.jpg');
const RithCarlton = ImportImages('/experiences/Toronto/rithcarlton.jpg');
const Hazelton = ImportImages('/experiences/Toronto/hazelton.jpg');
const Shangri = ImportImages('/experiences/Toronto/shangri.jpg');
const TorontoMain = ImportImages(
  '/experiences/Toronto/toronto-background-2.jpg'
);
const TorontoWelcome = ImportImages('/experiences/Toronto/toronto-welcome.jpg');

// Santa Barbara
const Belmond = ImportImages('/experiences/SantaBarbara/belmond.JPG');
const Orchid = ImportImages('/experiences/SantaBarbara/orchid.jpg');
const Polo = ImportImages('/experiences/SantaBarbara/polo.jpg');
const RitzCarlton = ImportImages('/experiences/SantaBarbara/ritzcarlton.jpg');
const Rosewood = ImportImages('/experiences/SantaBarbara/rosewood.jpg');
const Wahles = ImportImages('/experiences/SantaBarbara/wahles.jpg');
const WineTour = ImportImages('/experiences/SantaBarbara/blendingparty.jpg');
const SantaMain = ImportImages(
  '/experiences/SantaBarbara/santa-barbara-background.jpg'
);
const SantaWelcome = ImportImages(
  '/experiences/SantaBarbara/santa-barbara-welcome.jpg'
);
const SantaFour = ImportImages('/experiences/SantaBarbara/FourSeasons.jpg');
const Museum = ImportImages('/experiences/SantaBarbara/halloffame.jpg');

// San Francisco
const Fssf = ImportImages('/experiences/SanFrancisco/fssf.jpg');
//const AtelierCrenn = ImportImages('/experiences/SanFrancisco/ateliercrenn.jpg');
const ExteriorShot = ImportImages(
  '/experiences/SanFrancisco/exterior-shot.jpg'
);
const ScavengerShot = ImportImages(
  '/experiences/SanFrancisco/scavengerhunt.jpg'
);
const ThePalace = ImportImages('/experiences/SanFrancisco/thepalace.jpg');
const Halfmoon = ImportImages('/experiences/SanFrancisco/halfmoon.jpg');
const Lucasfilm = ImportImages('/experiences/SanFrancisco/lucasfilm.jpg');
const RitzCarltonsSf = ImportImages(
  '/experiences/SanFrancisco/ritzcarltonsf.jpeg'
);
const SfMona = ImportImages('/experiences/SanFrancisco/sfmona.jpg');
const SFMain = ImportImages(
  '/experiences/SanFrancisco/san-francisco-background.jpg'
);
const SFWelcome = ImportImages(
  '/experiences/SanFrancisco/san-francisco-welcome.jpg'
);

// New York
const Broadway = ImportImages('/experiences/NewYork/broadway.jpg');
const Crosby = ImportImages('/experiences/NewYork/crosby.jpg');
const Drawing = ImportImages('/experiences/NewYork/drawing.jpg');
const Exterior = ImportImages('/experiences/NewYork/exterior.jpg');
const PersonalShop = ImportImages('/experiences/NewYork/personalshop.jpg');
const PizzaTour = ImportImages('/experiences/NewYork/pizzatour.jpg');
const Baccarat = ImportImages('/experiences/NewYork/baccarat.jpg');
const Dancer = ImportImages('/experiences/NewYork/dancer.jpg');
const RitzCarltonNY = ImportImages('/experiences/NewYork/ritz-carlton.jpg');
const NYMain = ImportImages('/experiences/NewYork/new-york-background.jpg');
const NYWelcome = ImportImages('/experiences/NewYork/new-york-welcome.jpg');

// Montreal
const Perfune = ImportImages('/experiences/Montreal/perfume.jpg');
const Ritz = ImportImages('/experiences/Montreal/ritz.jpg');
const Trapeze = ImportImages('/experiences/Montreal/trapeze.jpeg');
const MontrealMain = ImportImages(
  '/experiences/Montreal/montreal-background.jpg'
);
const MontrealWelcome = ImportImages(
  '/experiences/Montreal/montreal-welcome.jpg'
);
const JoeBeef = ImportImages('/experiences/Montreal/joe-beef.jpg');
const WilliamGray = ImportImages('/experiences/Montreal/william-gray.jpg');

// Exclusive
const ArtBasel = ImportImages('/experiences/Exclusive/Tile/art-basel.jpg');
const ExBroadway = ImportImages('/experiences/Exclusive/Tile/broadway.jpg');
const BurningMan = ImportImages('/experiences/Exclusive/Tile/burning-men.jpg');
const GrandPrix = ImportImages('/experiences/Exclusive/Tile/grand-prix.jpg');
const RedCarpet = ImportImages('/experiences/Exclusive/Tile/red-carpet.jpg');
const PebbleBeach = ImportImages(
  '/experiences/Exclusive/Tile/pebble-beach.jpg'
);
const Singing = ImportImages(
  '/experiences/Exclusive/Tile/singing-lessons.jpeg'
);
const Timothy = ImportImages(
  '/experiences/Exclusive/Tile/timothy-eberly-515801-unsplash.jpg'
);

export default {
  exclusive: {
    ThingsToDo: [
      {
        ImgUrl: Timothy,
        FrameHeader: `Safety & Security`,
        visible: 0,
        FrameText:
          'Trident Response Group professionals will guide your family through training in Situational Awareness' +
          ' which will prove to be your most valuable “weapon/defense” as you navigate the world.'
      },
      {
        ImgUrl: RedCarpet,
        FrameHeader: `Film/TV`,
        visible: 0,
        FrameText:
          'John Wick Red Carpet Movie Premiere (May 9) – Walk the red carpet, join celebrities in viewing the' +
          ' movie, then head to the after party.'
      },
      {
        ImgUrl: Singing,
        FrameHeader: `Broadway`,
        visible: 0,
        FrameText:
          'Your Star is Born – How about private singing or dancing lessons with Broadway performer? Or, let’s go to' +
          ' the studio in LA so you can lay down a dynamite track with a famous producer.'
      },
      {
        ImgUrl: ExBroadway,
        FrameHeader: `Broadway`,
        visible: 0,
        FrameText:
          'JetSuite Coast to Coast - ESPY’s (July 10, 2019) & Tony Awards (June 9th, 2019) – After walking the red' +
          ' carpet with the all stars in Los Angeles takeoff for New York and be there as Broadway honors its' +
          ' brightest stars.'
      },
      {
        ImgUrl: ArtBasel,
        FrameHeader: `Art`,
        visible: 0,
        FrameText:
          'Art Basel Miami (Dec 5 -8, 2019) – Attend the exhibit previews, the hottest events, then party until' +
          ' sun comes at wit a VIP table at LIV or E11VEN.'
      },
      {
        ImgUrl: BurningMan,
        FrameHeader: `Music`,
        visible: 0,
        FrameText:
          'Burning Man (Aug 25, 2019 - Sept 2, 2019) – Your luxury RV will be waiting when you land, then enjoy' +
          ' the fun with VIP access.'
      },
      {
        ImgUrl: GrandPrix,
        FrameHeader: `Sports`,
        visible: 0,
        FrameText:
          'US Grand Prix, Austin, Texas (Nov 1-3, 2019) – After you visit the pits, head to the Owner’s Club and' +
          ' then join the victory party.'
      },
      {
        ImgUrl: PebbleBeach,
        visible: 0,
        FrameHeader: `Sports`,
        FrameText:
          'US Open Golf at Pebble Beach (Jun 13–16, 2019) – Enjoy VIP access, then meet the pros and hear about' +
          ' their greatest shots.'
      }
    ]
  },
  napa: {
    Title: 'JetSuite to Napa',
    Location: 'Napa',
    Image: NapaHotAir,
    Desc: `Jetsuite Experiences by Embark takes care of everything exept the private jet. Like JetSuite, the award winning travel advisors of Embark give you the one thing you can't but - Time. They find out what you want, then using their global network of relationships, do all the work to provide you the most memorable accomodations, VIP services and experiences - many that are not available to the general public. Together, we can handle your full range of travel needs. Click here to learn more about JetSuite Experiences by Embark`,
    WhyVisitImage: Welcome,
    WhyVisitText:
      'Napa Valley is an adult playground for savoring nature’s bounty and indulging in gastronomic food' +
      ' & wine experiences. Set amidst lush rolling valleys lines with picturesque vineyards, Napa is truly the' +
      ' Americana version of other famous wine regions such as those in Tuscany and Provence.\nFarm-to-table' +
      ' concepts fuse with selections of laid back, 5-star luxury resorts along with a host of activities meant to' +
      ' help you relax, delight or explore your active side. For oenophiles this is nirvana, with over 100' +
      ' wineries in just a 40 square mile radius, and whether it is a hot air balloon ride or exhilarating race' +
      ' car drive, there is truly something for everyone here.\nYour days can be spent reveling in fabulous feasts' +
      ' or just relaxing at a beautiful resort.',
    ThingsToDo: [
      {
        ImgUrl: Racing,
        visible: 1,
        LinkUrl: 'https://aubergeresorts.com/aubergedusoleil/',
        FrameHeader: `Racing School`,
        FrameText:
          'Simraceway Performance Driving Center - Start your engines and test your skils' +
          ' with half and full day McLaren experiences on the track or on the roads of Sonoma, and more!'
      },
      {
        ImgUrl: Croquet,
        visible: 1,
        LinkUrl: 'https://aubergeresorts.com/calistogaranch/',
        FrameHeader: 'Croquet Lessons',
        FrameText:
          'Become a pro with personalized croquet, then enjoy a 3-star Michelin, fine dining experience at Meadowood'
      },
      {
        ImgUrl: Ballon,
        visible: 1,
        LinkUrl: 'https://www.meadowood.com/',
        FrameHeader: 'Hot Air Balloon Ride',
        FrameText:
          'See the beauty of Napa from a hot air balloon as you feast on a gourment breakfast picnic'
      },
      {
        ImgUrl: JellyBelly,
        visible: 1,
        LinkUrl: 'https://www.singlethreadfarms.com/',
        FrameHeader: 'Jelly Belly© Tour',
        FrameText:
          "You'll be taken on a private tour behind-the-scenes at the Jelly Belly© factory, plus there are free samples!"
      },
      {
        ImgUrl: CookingNapa,
        visible: 1,
        LinkUrl: 'https://www.farmhouseinn.com/',
        FrameHeader: 'Cooking Lessons @ French Laundry',
        FrameText:
          "Don't just dine. We'll arrange for you to go into the kitchen and see how Thomas Keller's French Laundry became a world famous venue for foodies"
      }
    ],

    RecommendedLocales: [
      {
        ImgUrl: Auberge,
        LinkUrl: 'https://aubergeresorts.com/aubergedusoleil/',
        FrameHeader: 'Auberge du Soilel',
        FrameText:
          'One of the most romantic resorts in the Americas, Auberge overlooks vine-laden hills hailing to the French countryside.'
      },
      {
        ImgUrl: Meadowood,
        LinkUrl: 'https://www.meadowood.com/',
        FrameHeader: 'Meadowood',
        FrameText:
          'A great family option in the heart of Napa, set on a sprawling estate with a host of sporting options.'
      },
      {
        ImgUrl: Yoga,
        LinkUrl: 'https://aubergeresorts.com/calistogaranch/',
        FrameHeader: 'Calistoga Ranch',
        FrameText:
          'A rustic hideaway in the heart of Calistoga, ideal for nature lovers.'
      },
      {
        ImgUrl: SingleThread,
        LinkUrl: 'https://www.singlethreadfarms.com/',
        FrameHeader: 'Single Thread Farm',
        FrameText:
          'A foodie paradise, founded by acclaimed Michelin Chef Kyle Connaughton.'
      },
      {
        ImgUrl: Carneros,
        LinkUrl: 'https://www.carnerosresort.com/',
        FrameHeader: 'Carneros Resort and Spa',
        FrameText:
          'Private cottages surrounded by vineyards set on 28 acres of rolling hills.'
      },
      {
        ImgUrl: Bardessono,
        LinkUrl: 'https://www.bardessono.com/',
        FrameHeader: 'Bardessono',
        FrameText:
          'Bring your well-behaved best friend to the pool at this pet-friendly spa resort.'
      }
    ]
  },

  aspen: {
    Title: 'JetSuite to Aspen',
    Location: 'Aspen',
    Image: AspenMain,
    WhyVisitText:
      'Aspen is the St. Barts of the Rockies and now more than ever, it’s a year-round destination. In the winter it' +
      ' is the chic, see-and-be-seen destination, attracting a who’s who crowd. Aspen, however, is less' +
      ' pretentious. Aspen was a town before it was a ski village and for that reason, feels a lot more' +
      ' authentic.\nAs a century-old mining town, Aspen is adorable and full of personality, fusing local' +
      ' artisans and boutiques with Rodeo Drive name brands like Prada, Gucci and Louis Vuitton. Restaurants are' +
      ' as cosmopolitan as it gets with a rustic, down-home twist. Nightlife buzzes at places like the Caribou' +
      ' club, though nothing beats the après scene at the Little Nell.',
    WhyVisitImage: AspenWelcome,
    ThingsToDo: [
      {
        ImgUrl: Snowmobile,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Private Snowmobile Tour`,
        FrameText: `Enjoy the Rocky Mountain winter wonderland at full speed during this hair-raising snowmobile adventure through Aspen’s awesome backcountry.`
      },
      {
        ImgUrl: HikeMarron,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Hike Maroon Bells`,
        FrameText: `Take a scenic hike through Maroon Bells and take in breathtaking views of America’s most photographed peaks.`
      },
      {
        ImgUrl: WoodCreekBike,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Bike Ride to Woody Creek Tavern`,
        FrameText: `Bike along a rail-to-trail path to a dive bar where you can soak in local culture.`
      },
      {
        ImgUrl: Dog,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Dog Sledding Adventure`,
        FrameText: `This once-in-a-lifetime dog sledding experience in the Aspen backcountry is exhilarating.`
      },
      {
        ImgUrl: SkiInstruction,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Private Ski or Snowboard Instruction`,
        FrameText: `Tame the slopes with a professional coach during this customizable skiing or snowboarding lesson.`
      },
    ],

    RecommendedLocales: [
      {
        ImgUrl: StRegis,
        LinkUrl: 'https://www.stregisaspen.com/',
        FrameHeader: `St. Regis`,
        FrameText: `An elegant, urban resort located 2 blocks from the city lift and heart of the culinary scene in Aspen.`
      },
      {
        ImgUrl: Jerome,
        LinkUrl: 'https://aubergeresorts.com/hoteljerome/',
        FrameHeader: `Hotel Jerome`,
        FrameText: `A fabulous, cozy hotel in the center of Aspen’s shops, infused with an amazing western personality.`
      },
      {
        ImgUrl: LittleNell,
        LinkUrl: 'https://www.thelittlenell.com/',
        FrameHeader: `Little Nell`,
        FrameText: `At the base of the Ajax lifts, The Little Nell is the place to see and be seen.`
      }
    ]
  },

  charleston: {
    Title: 'JetSuite to Charleston',
    Location: 'Charleston',
    Image: CharlestonMain,
    WhyVisitText:
      'Charleston is one of the most charming cities in America. Voted World’s Best City by the' +
      ' readers of Travel + Leisure, it is the quintessential Southern city, full of classic plantations and' +
      ' blocks of perfectly restored buildings that truly make you feel like you either stepped back in time or' +
      ' into a movie set.\nIt boasts the largest preserved historic city in the world after Rome. There are' +
      ' over 90 blocks chock-full of over 2,000 preserved stately homes and mansions, many dating back over 300' +
      ' years.   For history buffs, Charleston allows you to delve into both the Revolutionary War and the Civil' +
      ' War, being a central site of both. In fact, the American Civil War started in Fort Sumter, which still' +
      ' stands in Charleston’s harbor today.\nThe culinary scene is one of the best in the country and has been' +
      ' making headlines for years.',
    WhyVisitImage: CharlestonWelcome,
    ThingsToDo: [
      {
        ImgUrl: Sailing,
        LinkUrl: 'https://www.jetsuite.com',
        FrameHeader: `Schooner Sailboat`,
        visible: 1,
        FrameText: `Sail the harbor on a classic Schooner sailboat for a great view of the city and enjoy a Southern feast from your private chef`
      },
      {
        ImgUrl: Golf,
        LinkUrl: 'https://www.jetsuite.com',
        FrameHeader: `Golf Outing`,
        visible: 1,
        FrameText: `Take a break from sightseeing and the culinary delights of Charleston and let us arrange your half day golf outing`
      },
      {
        ImgUrl: Cooking,
        LinkUrl: 'https://www.jetsuite.com',
        FrameHeader: `Cooking Class`,
        visible: 1,
        FrameText: `Cooking class with Celebrity Chef Bob Wagonner – Just off King Street, Chef Bob Wagonner has a fabulous dining and cooking studio where you can make your own lunch or dinner with this celebrity chef`
      },
      {
        ImgUrl: Garden,
        LinkUrl: 'https://www.jetsuite.com',
        FrameHeader: `Explore Secret Gardens`,
        visible: 1,
        FrameText: `Visit gorgeous “secret” private gardens hidden behind some of Charleston’s private mansions`
      },
      {
        ImgUrl: Plantation,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Plantation Visits`,
        FrameText: `Boon Hall, Drayton Hall and Middleton Plantation are all about 30 minutes from Charleston`
      }
    ],

    RecommendedLocales: [
      {
        ImgUrl: Charleston,
        LinkUrl:
          'https://www.belmond.com/hotels/north-america/usa/sc/charleston/belmond-charleston-place/',
        FrameHeader: `Belmond Charleston Place`,
        FrameText: `Located right in the middle of King Street’s best shopping and within easy reach of anything in town. Its facilities are second to none in the city, including a full spa, indoor pool, nicely sized gym, and restaurants.`
      },
      {
        ImgUrl: WentWorth,
        LinkUrl: 'https://www.wentworthmansion.com/',
        FrameHeader: `Wentworth Mansion`,
        FrameText: `By far the most luxurious option in town for people who want a strong sense of place. Built in 1886 by a wealthy merchant and incredibly restored in 1998 to all its glory, this 21 room gem will make  you feel like you stepped back in time as a house guest to one of the wealthiest southerners of the time.`
      },
      {
        ImgUrl: ZeroGeorge,
        LinkUrl: 'https://zerogeorge.com/',
        FrameHeader: `Zero George Street`,
        FrameText: `Circa 1804 buildings surround a private courtyard providing authentic, understated luxury with 16 guest rooms and suites, the branchild of former Orient-Express president Dean Andrews Porter and his wife Lynn Easton.`
      },
      {
        ImgUrl: Dewberry,
        LinkUrl: 'https://www.thedewberrycharleston.com/',
        FrameHeader: `The Dewberry Charleston`,
        FrameText: `A restored mid-century Federal office building, you'll feel like you've stepped into a private club with lots of luxurious wood paneling, comfortable leather chairs and plenty of southern charm. Make sure to take a bicycle out for a spin. They're complimentary for guests.`
      }
    ]
  },

  'west-palm-beach-miami': {
    Title: 'JetSuite to Miami',
    Location: 'Miami',
    Image: MiamiMain,
    WhyVisitText:
      'The most vibrant beach town in America, Miami offers powder white beaches and turquoise waters' +
      ' with a sophisticated scene nodding to its Latin influence. Miami is a collection of neighborhoods, each' +
      ' with its own vibe. Its preserved neon-lit, Art Deco district is one of the most remarkable in the world' +
      ' while its restaurant scene is one of the best in the country, with an amazing variety of cuisines and' +
      ' scenes.\nFor culture enthusiasts, there are endless art galleries, museums, and street art. Brickell,' +
      ' Coral Gables and Coconut Grove are also great alternatives to staying on Miami Beach. The city is friendly' +
      ' and accommodating to singles, couples, and families.',
    WhyVisitImage: MiamiWelcome,
    ThingsToDo: [
      {
        ImgUrl: SwampTour,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Airboat Tour`,
        FrameText: `Explore nature on a private Airboat tour through the Everglades National Park`
      },
      {
        ImgUrl: Cheefs,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Chef's Table @ Los Fuegos`,
        FrameText: `Francis Mallmann will introduce you to the tasty art of live-fire cooking before you indulge in the spectacular dining at his Los Fuegos`
      },
      {
        ImgUrl: SeaPlane,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Seaplane Tour`,
        FrameText: `Takeoff in a seaplane for a daytrip to the keys from Pan Am's former base on Watson Island`
      },
      {
        ImgUrl: VipTable,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Nightclub VIP Table`,
        FrameText: `In Miami, the clubs stay open 24 hours, so let us get you a 'must have' VIP table`
      }
    ],

    RecommendedLocales: [
      {
        ImgUrl: Acqualina,
        LinkUrl: 'https://www.acqualinaresort.com/',
        FrameHeader: `Acqualina`,
        FrameText: `A family’s dream resort with sumptuous oversized apartment-style units and elegant service on the seaside, located in a residential North Miami beach town.`
      },
      {
        ImgUrl: Harbour,
        LinkUrl:
          'https://www.marriott.com/hotels/travel/miaxr-the-st-regis-bal-harbour-resort/',
        FrameHeader: `St. Regis Bal Harbour`,
        FrameText: `Set in the heart of the swanky town of Bal Harbour – Miami’s Beverly Hills, this marble-laden hotel bustles with glitz.`
      },
      {
        ImgUrl: Faena,
        LinkUrl: 'https://zerogeorge.com/',
        FrameHeader: `Faena`,
        FrameText: `A whimsical, almost theatrical hotspot right in the heart of Miami’s North Beach, infused with priceless art.`
      },
      {
        ImgUrl: Lobby,
        LinkUrl: 'https://www.editionhotels.com/miami-beach/',
        FrameHeader: `Edition Hotel`,
        FrameText: `The best trendy hotel option with luxury touches that include a bowling alley and ice skating rink.`
      },
      {
        ImgUrl: Setai,
        LinkUrl: 'https://www.thesetaihotels.com/en-us/hotels/miami-beach',
        FrameHeader: `Setai`,
        FrameText: `An Asian-inspired oasis of luxury in the middle of the South Beach bustle.`
      }
    ]
  },

  toronto: {
    Title: 'JetSuite to Toronto',
    Location: 'Toronto',
    Image: TorontoMain,
    WhyVisitText:
      'Toronto has blossomed into an incredibly cool, trendy and fun city over the past decade. It is Canada’s' +
      ' financial hub with a buzzing late-night scene. Located on Lake Ontario just above upstate New York and 60' +
      ' miles from Niagara Falls, the incredible redevelopment has transformed Toronto into a vibrant cosmopolitan' +
      ' city with hipster neighborhoods, first-rate theater, burgeoning art scene, and an amazing range of' +
      ' restaurants and cuisines. It is also a sports bastion with its hockey culture and strong following for the' +
      ' only professional NBA Basketball and Major League Baseball teams outside of the U.S.',
    WhyVisitImage: TorontoWelcome,
    ThingsToDo: [
      {
        ImgUrl: HallOfFame,
        LinkUrl: 'https://www.jetsuite.com',
        FrameHeader: `Hockey Hall of Fame`,
        visible: 1,
        FrameText: `A vast collection of hockey memorabilia, including famous gear, interactive games and the Stanley Cup`
      },
      {
        ImgUrl: KingWest,
        LinkUrl: 'https://www.jetsuite.com',
        FrameHeader: `Roy Thomson Hall Performance`,
        visible: 1,
        FrameText: `Home to the Toronto Symphony Orchestra, is world renowned for its acoustics and we can get you the best seats...and back stage access`
      },
      {
        ImgUrl: ChineTown,
        LinkUrl: 'https://www.jetsuite.com',
        FrameHeader: `Chinatown Food Tour`,
        visible: 1,
        FrameText: `Let us arrange a private banquet at Toronto's best Chinese restaurants`
      },
      {
        ImgUrl: CnTower,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `CN Tower Edgewalk`,
        FrameText: `Walk around the top of the CN Tower, 116 stories above the city, on a five foot wide ledge without railings`
      }
    ],

    RecommendedLocales: [
      {
        ImgUrl: FourSeasons,
        LinkUrl: 'https://www.fourseasons.com/toronto/',
        FrameHeader: `Four Seasons`,
        FrameText: `Newly built, it is the elegant “Upper East Side” hotel of Toronto with beautiful contemporary interiors.`
      },
      {
        ImgUrl: Hazelton,
        LinkUrl: 'https://thehazeltonhotel.com/',
        FrameHeader: `Hazelton`,
        FrameText: `The boutique, lifestyle is a chic option in Yorkville.`
      },
      {
        ImgUrl: RithCarlton,
        LinkUrl: 'http://www.ritzcarlton.com/en/hotels/canada/toronto',
        FrameHeader: `The Ritz Carlton`,
        FrameText: `With a stand-out location in the heart of the waterfront, it offers the best views in the city overlooking the skyscape and waterfront.`
      },
      {
        ImgUrl: Shangri,
        LinkUrl: 'https://www.shangri-la.com/toronto/shangrila/',
        FrameHeader: `The Shangri La`,
        FrameText: `Located in the middle of the downtown business district with an Asian flair.`
      }
    ]
  },

  'santa-barbara': {
    Title: 'JetSuite to Santa Barbara',
    Location: 'Santa Barbara',
    Image: SantaMain,
    WhyVisitText:
      'Santa Barbara is known as the American Riviera. There are many weekend mansions that overlook the majestic' +
      ' coast in the hilly Santa Barbara region.  Known for its Spanish Missionary architecture with white walls' +
      ' and orange terracotta roofs, the city is quaint and beautiful. Towering mountains are a backdrop for the' +
      ' beach and town.\nThe landscaping of Santa Barbara is one of the city’s most unique aspects. The main town' +
      ' is small, with two-mile State Street being the central commercial artery with galleries and shops. There' +
      ' are cute boutiques and cafes, making it a really pleasant stroll. Along the way, the 1920’s built' +
      ' courthouse and mission are beautiful, not just for their Missionary architecture but also for their' +
      ' verdant gardens.',
    WhyVisitImage: SantaWelcome,
    ThingsToDo: [
      {
        ImgUrl: Museum,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Private Museum Tour`,
        FrameText: `The Santa Barbara Museum of Art is known for its Claude Monet collection amongst its 27,000 works`
      },
      {
        ImgUrl: Orchid,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Orchid Estate Tour`,
        FrameText: `Visit Santa Barbara Orchid Estate, home to one of the world's foremost collections of orchid species and hybrids`
      },
      {
        ImgUrl: WineTour,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Wine Tour`,
        FrameText: `For a different wine experience, let us guide you through the more than 30 tasting rooms and wine bars`
      },
      {
        ImgUrl: Wahles,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Whale Watching`,
        FrameText: `Head out for a whale-watching cruise`
      },
      {
        ImgUrl: Polo,
        LinkUrl: 'https://www.jetsuite.com',
        FrameHeader: `Stomp The Divots `,
        visible: 1,
        FrameText: `VIP Section for Santa Barbara Polo`
      }
    ],

    RecommendedLocales: [
      {
        ImgUrl: SantaFour,
        LinkUrl: 'https://www.fourseasons.com/santabarbara/',
        FrameHeader: `Four Seasons Santa Barbara`,
        FrameText: `An oceanfront hotel (sans ocean view rooms) right on the beach, with a heavy Spanish Missionary style - ideal for families and groups.`
      },
      {
        ImgUrl: Belmond,
        LinkUrl:
          'https://www.belmond.com/hotels/north-america/usa/ca/santa-barbara/belmond-el-encanto/',
        FrameHeader: `Belmond El Encanto`,
        FrameText: `Also located in the mountains, it is similar to San Ysidro and is a great romantic escape that has more of a vibe than San Ysidro with an amazingly fresh room product and incredible views.`
      },
      {
        ImgUrl: Rosewood,
        LinkUrl:
          'https://www.rosewoodhotels.com/en/miramar-beach-montecito?gclid=EAIaIQobChMIwK2xmO254QIVRbaWCh3E3gtpEAAYASAAEgJi1PD_BwE&gclsrc=aw.ds',
        FrameHeader: `Rosewood Miramar Beach`,
        FrameText: `California's newest luxury resort and spa is set right on the beach. Choose from a variety of suites and bungalows that are just steps from the Pacific Ocean.`
      },
      {
        ImgUrl: RitzCarlton,
        LinkUrl:
          'http://www.ritzcarlton.com/en/hotels/california/santa-barbara',
        FrameHeader: `The Ritz-Carlton Bacara, Santa Barbara`,
        FrameText: `Set on 78 acres, enjoy the spa or your own private cabana. There are three heated, zero-edged pools.`
      }
    ]
  },

  'san-francisco': {
    Title: 'JetSuite to San Francisco',
    Location: 'San Francisco',
    Image: SFMain,
    WhyVisitText:
      'Perched on the northern tip of a peninsula, San Francisco is surrounded on three sides by water. Forty-nine' +
      ' hills stud "the City" (as San Franciscans call it), accounting for the bounty of breathtaking views.' +
      ' Explore the magnificent San Francisco Bay: a city of neighborhoods, each with its own distinct character' +
      ' and attractions.\nOf course, part of the fun in visiting San Francisco is dining out. Its numerous' +
      ' well-established and historic venues, some dating back over 100 years, are matched by its reputation for' +
      ' being an incubator for new and upcoming chefs.\nWith 12 distinct neighborhoods, all popular' +
      ' destinations, San Francisco is “The City” to be visited more than once.',
    WhyVisitImage: SFWelcome,
    ThingsToDo: [
      {
        ImgUrl: ScavengerShot,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Scavenger Hunt`,
        FrameText: `Let us arrange a fun family scavenger hunt, taking you around San Francisco’s favorite landmarks`
      },
      {
        ImgUrl: Lucasfilm,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Lucasfilm Tour`,
        FrameText: `Follow in the steps of Luke Skywalker with a VIP tour of Lucasfilm`
      },
      {
        ImgUrl: SfMona,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Private Museum Tour`,
        FrameText: `Enjoy the San Francisco Museum of Modern Art by private guide`
      }
    ],

    RecommendedLocales: [
      {
        ImgUrl: ExteriorShot,
        LinkUrl: 'https://www.fairmont.com/claremont-berkeley/',
        FrameHeader: `The Claremont Club and Spa, A Fairmont Hotel`,
        FrameText: `Located in Berkeley, this grand dame recently celebrated its 100th anniversary and will remind you of the Golden State circa early 20th Century. Its extensive Fairmont Spa with over 30 treatment rooms is reason enough to visit.`
      },
      {
        ImgUrl: Halfmoon,
        LinkUrl:
          'http://www.ritzcarlton.com/en/hotels/california/half-moon-bay',
        FrameHeader: `The Ritz-Carlton, Half Moon Bay`,
        FrameText: `Less than an hour south of San Francisco, play golf with views of the Pacific Ocean, then relax in the full-service spa, complete with 13 treatment rooms.`
      },
      {
        ImgUrl: ThePalace,
        LinkUrl:
          'https://www.marriott.com/hotels/travel/sfolc-palace-hotel-a-luxury-collection-hotel-san-francisco/',
        FrameHeader: `The Palace San Francisco`,
        FrameText: `A beautifully restored grand dame hotel in the center of it all with an amazing sense of place and history. Steps from the best shopping in the city and the beautiful Embarcadero waterfront promenade, it has one of the most beautiful winter garden courts and indoor pools in the city. `
      },
      {
        ImgUrl: Fssf,
        LinkUrl: 'https://www.fourseasons.com/sanfrancisco/',
        FrameHeader: `Four Seasons San Francisco`,
        FrameText: `A lovely luxury hotel with a cool restaurant and convenient location in between the Embarcadero and Union Square shops.`
      },
      {
        ImgUrl: RitzCarltonsSf,
        LinkUrl:
          'http://www.ritzcarlton.com/en/hotels/california/san-francisco',
        FrameHeader: `The Ritz-Carlton, San Francisco`,
        FrameText: `A beautiful, elegant luxury hotel on Nob Hill just off of Union Square with fabulous club floor access and suites.`
      }
    ]
  },

  'new-york': {
    Title: 'JetSuite to New York',
    Location: 'New York',
    Image: NYMain,
    WhyVisitText:
      '“The City That Never Sleeps” is steeped in energy and endless diversions. From shopping and art to fashion,' +
      ' theater and finance, New York is the capital of commerce and culture in America. It is a city of' +
      ' neighborhoods, each unfolding another reflection on its diverse population – truly the melting pot of the' +
      ' world.\nWhile exploring New York can be very much about checking off your list of endless museums,' +
      ' monuments,' +
      ' rooftop vantage points, restaurants, lounges and theaters, it is also a place to explore local areas like' +
      ' SoHo, TriBeCa, FiDi, Flatiron, and the Upper East Side – in addition to neighborhoods like Dumbo and' +
      ' Williamsburg in Brooklyn. What’s best is that you can visit New York over and over again and see it in a' +
      ' completely different light with a completely different vibe.',
    WhyVisitImage: NYWelcome,
    ThingsToDo: [
      {
        ImgUrl: PizzaTour,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Pizza Tour`,
        FrameText: `Pizza lovers will love our personal, guided tour of New York City's best joints!`
      },
      {
        ImgUrl: Dancer,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Dancing Lessons`,
        FrameText: `Visit Rockefeller Center for a private dancing lesson with one of the famous Rockettes`
      },
      {
        ImgUrl: Broadway,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Backstage Access`,
        FrameText: `Better than front row seats at a Broadway show, also go backstage to meet the cast`
      },
      {
        ImgUrl: PersonalShop,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `VIP Personal Shopper`,
        FrameText: `Your style is our pleasure as your personal shopper takes you for a VIP day of excitement`
      }
      /*{
        ImgUrl: Scavenger,
        LinkUrl: 'https://www.jetsuite.com',
        FrameHeader: `Chef's Table`,
        FrameText: `Let us book the Chef’s table at Thomas Keller’s TAK Room at Hudson Y`
      }*/
    ],

    RecommendedLocales: [
      {
        ImgUrl: Exterior,
        LinkUrl: 'https://www.theplazany.com/',
        FrameHeader: `The Plaza`,
        FrameText: `The iconic New York hotel is centrally located and the essence of classic New York. If you have a special little girl, let us arrange a memorable weekend starting with the Eloise Suite.`
      },
      {
        ImgUrl: Baccarat,
        LinkUrl: 'https://www.baccarathotels.com/',
        FrameHeader: `The Baccarat`,
        FrameText: `An elegant hotel, perfectly located in Midtown, is the new gathering place for the city’s power players, infused with Baccarat style.`
      },
      {
        ImgUrl: RitzCarltonNY,
        LinkUrl: 'http://www.ritzcarlton.com/en/hotels/new-york/central-park',
        FrameHeader: `The Ritz Carlton New York, Central Park`,
        FrameText: `We can reserve a park view room for you. With postcard views, you may not want to leave your cocoon of luxury, however, when you do, you will be steps from Fifth Avenue, Rockefeller Center, Broadway and all the activites of the great park across the street.`
      },
      {
        ImgUrl: Crosby,
        LinkUrl:
          'https://www.firmdalehotels.com/hotels/new-york/crosby-street-hotel/',
        FrameHeader: `The Crosby`,
        FrameText: `A stylish, whimsical boutique hotel in the heart of SoHo.`
      },
      {
        ImgUrl: Drawing,
        LinkUrl: 'https://www.thegreenwichhotel.com/',
        FrameHeader: `The Greenwich`,
        FrameText: `A coveted boutique hotel in TriBeCa, just blocks from SoHo and the Financial District. For an over-the-top stay, we recommend the TriBeCa Penthouse.`
      }
    ]
  },

  montreal: {
    Title: 'JetSuite to Montreal',
    Location: 'Montreal',
    Image: MontrealMain,
    WhyVisitText:
      'Montreal offers old, pre-colonial buildings and history mixed with towering buildings housing offices and' +
      ' condominiums with a French flair. Located at the mouth of the St. Lawrence River, just north of Vermont,' +
      ' Montreal is the capital of Quebec, the French-speaking province of Canada.\nThere is a great district on' +
      ' the riverfront known as “Old Montreal” which is charming.  It is about 15 blocks long and three blocks' +
      ' wide, lined with a few galleries, restaurants and lots of souvenir shops and bars. The area sits on the' +
      ' riverfront, which is an expansive and redeveloped section of the city hosting an over-the-top Cirque du' +
      ' Soilel tent (Montreal is Cirque’s headquarters), several exhibition halls and museums, including a great' +
      ' museum of Science.',
    WhyVisitImage: MontrealWelcome,
    ThingsToDo: [
      {
        ImgUrl: Trapeze,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Trapeze Lessons`,
        FrameText: `Let us arrange private lessons at Le Chateau de Cirque as a prelude to a VIP Cirque du Soilel performance`
      },
      {
        ImgUrl: Perfune,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Fragrance Making`,
        FrameText: `Ruby Brown, a former actress, model and perfume maker, takes you on a journey to create your very own perfume`
      },
      {
        ImgUrl: JoeBeef,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Dine @ Joe Beef`,
        FrameText: `One-of-a-kind dining experience at one of the world’s most renowned restaurants`
      }
    ],

    RecommendedLocales: [
      {
        ImgUrl: Ritz,
        LinkUrl: 'http://www.ritzcarlton.com/en/hotels/canada/montreal',
        FrameHeader: `Ritz Carlton Montreal`,
        FrameText: `This is the beautiful Grand Dame of the City located in the leafy Golden Mile one block from the art museum district and one block from the park. It is a classical hotel with fresh style.`
      },
      {
        ImgUrl: WilliamGray,
        LinkUrl: 'https://hotelwilliamgray.com/',
        FrameHeader: `William Gray`,
        FrameText: `Located in a 300 year old building in the heart of Old Montreal, the William Gray is contrasted with cool, modern interiors with a very boutique vibe.`
      }
    ]
  },
  
  // New data
  scottsdale: {
    Title: 'JetSuite to Scottsdale',
    Location: 'Scottsdale',
    Image: ScottsdaleWelcome,
    WhyVisitText:
        'Located in the beautiful Sonoran Desert, Scottsdale, Arizona is bordered by Phoenix to the west and the' +
        ' McDowell Mountains to the east. Scottsdale is annually rated among the nation’s most desirable communities' +
        ' to live, visit and do business. Scottsdale’s vibrant Old Town is considered the finest urban center' +
        ' in Arizona. It is home to more than 800 restaurants, 2,500 retail shops and more than 80 art galleries.',
    WhyVisitImage: WhyScottsdale,
    ThingsToDo: [
      {
        ImgUrl: FrankLloyd,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Frank Lloyd Wright Behind-the-scenes Taliesin West Tour`,
        FrameText: `Experience a favorite dwelling of Frank Lloyd Wright, Taliesin West. Enjoy a behind-the-scenes tour with mid-morning tea.`
      },
      {
        ImgUrl: DesertBiking,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Desert Biking Excursion`,
        FrameText: `Bike through the dramatic desert landscape, passing endemic plant and animal life on this privately guided tour!`
      },
      {
        ImgUrl: CowboyExp,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Family-friendly Cowboy Experience`,
        FrameText: `Take a roping and riding adventure and get a taste of the Wild West followed by cowboy lunch.`
      },
      {
        ImgUrl: KayakingTour,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Private River Kayaking Tour`,
        FrameText: `Kayak a desert river and enjoy learning about the diversity of plant and animal life.`
      },
      {
        ImgUrl: DesertHiking,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Sonoran Desert Hiking Tour`,
        FrameText: `A private guide leads your hike through the Sonoran Desert to discover the beauty of the land.`
      }
    ],
    
    RecommendedLocales: [
      {
        ImgUrl: FourseasonsScottsdale,
        LinkUrl: 'https://www.fourseasons.com/scottsdale/',
        FrameHeader: `Four Seasons Resort Scottsdale at Troon North`,
        FrameText: `Located adjacent to Weiskopf and Moorish-designed golf courses. Experience breathtaking views of Pinnacle Peak, rock formations, downtown Phoenix, and 40 acres of vibrant desert blooms. All guest rooms have spacious private balconies or patios.`
      },
      {
        ImgUrl: SanctuaryCamel,
        LinkUrl: 'https://www.sanctuaryoncamelback.com/',
        FrameHeader: `Sanctuary on Camelback Mountain Resort & Spa`,
        FrameText: `Sanctuary on Camelback Mountain, Resort & Spa offers its guests unparalleled privacy and peace. Perfectly positioned to enjoy a private desert view, all accommodations offer privacy, inviting guests to indulge in contemplation, relaxation, and renewal.`
      },
      {
        ImgUrl: CanyonSuites,
        LinkUrl: 'https://www.canyonsuites.com/',
        FrameHeader: `The Canyon Suites at The Phoenician, a Luxury Collection Resort, Scottsdale`,
        FrameText: `Step into enchanting boutique resort hidden within a larger resort. Replete with sophisticated style and personal service, The Canyon Suites at The Phoenician offers you an oasis of glamour and grandeur that’s truly rare. `
      }
    ]
  },
  'san-diego': {
    Title: 'JetSuite to San Diego',
    Location: 'San Diego',
    Image: SanDiegoWelcome,
    WhyVisitText:
        'A beach town equal parts relaxing and electrifying, San Diego’s water-centered lifestyle translates to its' +
        ' atmosphere. Head to the historic Gaslamp Quarter for dining, shopping, and lively nightlife, walk the' +
        ' waterfront Embarcadero or stop into the East Village’s indie shops and cafes. Wherever you go, you’ll be' +
        ' sure to take in stunning, sweeping sea views with the warm sun sparkling among the iridescent blue.',
    WhyVisitImage: WhySanDiego,
    ThingsToDo: [
      {
        ImgUrl: WhaleWatching,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Private Whale Watching Sailboat Charter`,
        FrameText: `Sail the coastal waters in search of whales and other marine life from mid-December through April!`
      },
      {
        ImgUrl: DowntownSan,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Private Old Town San Diego Food & Wine Tour`,
        FrameText: `Discover historic Old Town San Diego, the site of California's first European settlement, on a private culinary tour!`
      },
      {
        ImgUrl: WineTourSanDiego,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Private San Diego County Wine Tour`,
        FrameText: `Visit charming wineries with an expert who will take you to the blossoming vineyards of Escondido and Ramona.`
      },
      {
        ImgUrl: Giraffes,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `VIP San Diego Zoo Safari Park`,
        FrameText: `See endangered wildlife with expert biologists who care for them behind-the-scenes at San Diego Zoo Safari Park.`
      },
      {
        ImgUrl: SilhouetteNaval,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `San Diego Bay Naval History Tour on a Historic Swift Boat`,
        FrameText: `Zoom through San Diego Bay aboard a twin 12-cylinder naval swift boat on a thrilling ride.`
      }
    ],
    
    RecommendedLocales: [
      {
        ImgUrl: PendrySanDiego,
        LinkUrl: 'https://www.pendry.com/san-diego/',
        FrameHeader: `Pendry San Diego`,
        FrameText: `Located in the Gaslamp Quarter, Pendry San Diego offers nightlife, nearby beaches, and shopping. The hotel balances modern and traditional, pairing classic Southern California influence with modern luxury programming and amenities.`
      },
      {
        ImgUrl: LodgeAtTorrey,
        LinkUrl: 'https://www.lodgetorreypines.com/',
        FrameHeader: `The Lodge at Torrey Pines`,
        FrameText: `The Lodge at Torrey Pines is located in La Jolla overlooking the Pacific, immediately adjacent to the Torrey Pines Golf Course. Custom-designed furniture, fabrics and carpets give the rooms a feel of elegance and warmth.`
      },
      {
        ImgUrl: FairmontGrand,
        LinkUrl: 'https://www.fairmont.com/san-diego/',
        FrameHeader: `Fairmont Grand Del Mar`,
        FrameText: `Capturing the elegance and comfort of an old-world Mediterranean estate, San Diego's luxury Fairmont Grand Del Mar golf resort and spa welcomes guests to Southern California with signature charm and impeccable service.`
      }
    ]
  },
  
  denver: {
    Title: 'JetSuite to Denver',
    Location: 'Denver',
    Image: DenverWelcome,
    WhyVisitText:
        'From microbreweries to the Rocky Mountains, Denver effortlessly blends hip metropolitan life with rustic,' +
        ' outdoors-centered vibes. Nicknamed the Mile High City for sitting at one mile above sea level – it offers' +
        ' a variety of activities for the mountain-meets-metro enthusiast. Hiking, biking, snowboarding, and skiing;' +
        ' local bands, boutiques, brews, and grub: Denver has a mixture of the good stuff for your viewing and' +
        ' visiting pleasures.',
    WhyVisitImage: WhyDenver,
    ThingsToDo: [
      {
        ImgUrl: SupercarExp,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Supercar Driving Experience`,
        FrameText: `Drive Colorado's most scenic country byways along winding canyon roads behind the wheel of a supercar.`
      },
      {
        ImgUrl: RockyMountain,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Rocky Mountain Horseback Ride`,
        FrameText: `Take a scenic horseback ride through the foothills of Rocky Mountain National Park.`
      },
      {
        ImgUrl: BeerCompany,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Craft Brewery Tour`,
        FrameText: `Explore historic downtown one beer at a time with a guide taking you behind-the-scenes at award-winning microbreweries.`
      },
      {
        ImgUrl: HikingColorado,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Rocky Mountain National Park Hiking Tour`,
        FrameText: `Hike and drive this national park with a naturalist showing you the best of Colorado’s nature.`
      }
    ],
    
    RecommendedLocales: [
      {
        ImgUrl: FourSeasonsDenver,
        LinkUrl: 'https://www.fourseasons.com/denver/',
        FrameHeader: `Four Seasons Hotel Denver`,
        FrameText: `Four Seasons Hotel Denver is an icon at 14th and Arapahoe – across the street from the Denver Performing Arts Complex and steps from Larimer Square, the 16th Street Mall and lively Lower Downtown (“LoDo”).`
      },
      {
        ImgUrl: RcTent,
        LinkUrl: 'https://www.ritzcarlton.com/en/hotels/colorado/denver',
        FrameHeader: `The Ritz-Carlton, Denver`,
        FrameText: `The newly enhanced and highly sophisticated Ritz-Carlton is centered in the heart of downtown. The hotel's location offers easy access to the theatre and business districts, Larimer Square, Coors Field and the famed LoDo area.`
      }
    ]
  },
  
  'd-c': {
    Title: 'JetSuite to D.C.',
    Location: 'D.C.',
    Image: DCWelcome,
    WhyVisitText:
        'Prime shopping and dining options pervade the bustling U.S. capital, where you can visit cultural' +
        ' institutions, tour historic monuments and weave your way through museums against the beautiful backdrop of' +
        ' the Potomac and Anacostia rivers. Monuments and memorials, eclectic neighborhoods, true local flavor –' +
        ' Washington, DC is a place unlike any other. It’s your home away from home with museums, endless sites and' +
        ' America’s front yard.',
    WhyVisitImage: WhyDC,
    ThingsToDo: [
      {
        ImgUrl: WhiteHouse,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Private White House Tour`,
        FrameText: `Our fully private tour of the White House building will take you inside the building’s rich history.`
      },
      {
        ImgUrl: AtNightDC,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Washington, D.C. At Night`,
        FrameText: `At night Washington’s monuments glow, creating a majestic cityscape to enjoy on a private after hours tour.`
      },
      {
        ImgUrl: CivilWar,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Civil War Sites Excursion`,
        FrameText: `Learn about the Civil War with an expert historian, touring the local sites where catalytic moments occurred.`
      }
    ],
    
    RecommendedLocales: [
      {
        ImgUrl: RosewoodDC,
        LinkUrl: 'https://www.rosewoodhotels.com/en/washington-dc',
        FrameHeader: `Rosewood Washington DC`,
        FrameText: `Relax at the Rooftop Lounge and infinity pool with sweeping views of historic Georgetown and the Potomac River. Just 49 rooms and suites entice with museum-quality artwork, circular bathtubs and every conceivable amenity.`
      },
      {
        ImgUrl: HayAdams,
        LinkUrl: 'https://www.hayadams.com/',
        FrameHeader: `The Hay-Adams`,
        FrameText: `Situated in Lafayette Square with the Smithsonian museums and the Washington Monument only moments away, it’s a great choice for familes! The hotel offers a variety of elegant rooms and suites with White House views.`
      },
      {
        ImgUrl: FourseasonsDC,
        LinkUrl: 'https://www.fourseasons.com/washington/',
        FrameHeader: `Four Seasons Hotel Washington, DC`,
        FrameText: `Located at the door to Georgetown, there are 222 guestrooms, including 58 suites. Seasons is the locale for movers and shakers at breakfast. Dinner at Michael Mina’s Bourbon Steak will tempt you with haute American classics.`
      },
      {
        ImgUrl: Mandarin,
        LinkUrl: 'https://www.mandarinoriental.com/washington/national-mall/luxury-hotel',
        FrameHeader: `Mandarin Oriental, Washington D.C.`,
        FrameText: `On the waterfront, the MO is walking distance to monuments, the National Mall and Smithsonian museums. Adjacent is District Wharf, a new neighborhood of restaurants, shops and entertainment. Newly renovated guestrooms offer impressive views.`
      }
    ]
  },
  
  nashville: {
    Title: 'JetSuite to Nashville',
    Location: 'Nashville',
    Image: NashvilleWelcome,
    WhyVisitText:
        'Nashville is authentic and friendly with diverse neighborhoods, a unique musical heritage and a creative' +
        ' culture that pervades the city. Experience the creative energy. Discover the neighborhoods. Seek out the' +
        ' hidden gems. Uncover the history and the history in the making. And of course, enjoy the music.',
    WhyVisitImage: WhyNashville,
    ThingsToDo: [
      {
        ImgUrl: RecordingStudio,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Private Recording Session With a Nashville Star`,
        FrameText: `Experience Nashville’s singer-songwriter culture with a nationally acclaimed performer during this private recording studio session.`
      },
      {
        ImgUrl: OldOpry,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `VIP Tour Grand Old Opry`,
        FrameText: `Enjoy green room access and premium side stage seating at Nashville’s iconic Grand Ole Opry.`
      },
      {
        ImgUrl: CookingClass,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Private Southern Cooking Class`,
        FrameText: `Indulge in a private cooking class with a Southern inspired menu featuring iconic Nashville flavors.`
      },
      {
        ImgUrl: BbqBeer,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Nashville BBQ & Beer Tour`,
        FrameText: `Taste Nashville’s BBQ with a culinary guide who will take you to national recognized and local favorites.`
      },
      {
        ImgUrl: HistoricTour,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Private Historic Nashville City Tour`,
        FrameText: `Explore the birthplace of country music on this customizable, private guided tour of its most iconic sites.`
      }
    ],
    
    RecommendedLocales: [
      {
        ImgUrl: HermitageHotel,
        LinkUrl: 'https://www.thehermitagehotel.com/',
        FrameHeader: `The Hermitage Hotel`,
        FrameText: `Located in the heart of downtown Nashville. Rooms offer a rich tapestry of elegant furnishings and appointments, with many of them offering spectacular views of the State Capitol and the Nashville skyline.`
      },
      {
        ImgUrl: ThompsonNashville,
        LinkUrl: 'https://www.thompsonhotels.com/hotels/tennessee/nashville',
        FrameHeader: `Thompson Nashville`,
        FrameText: `The Thompson is at the heart of this little big town’s explosive growth, weaving an energetic new neighborhood luxury hotel destination into the local fabric.`
      },
      {
        ImgUrl: NoelleNashville,
        LinkUrl: 'https://www.noelle-nashville.com/',
        FrameHeader: `Noelle Nashville`,
        FrameText: `Designed with a curator's touch, the hotel is steps from Printer's Alley. Immerse yourself in elegance amid intuitively designed rooms and suites with 5-star amenities, fine appointments, floor-to-ceiling windows and sweeping views of the cityscape.`
      },
      {
        ImgUrl: HuttonHotel,
        LinkUrl: 'https://www.huttonhotel.com/',
        FrameHeader: `Hutton Hotel`,
        FrameText: `Hutton Hotel offers guests an immersive journey into Nashville's creative culture. Known for the first lifestyle hotel in Nashville with distinctive Southern-style hospitality.`
      }
    ]
  },
  
  dallas: {
    Title: 'JetSuite to Dallas',
    Location: 'Dallas',
    Image: DallasWelcome,
    WhyVisitText:
        `If you're looking for cultural gems, activities with the kids, or a fun night out on the town, Dallas has so many things to do for your next big adventure: from the classics like Reunion Tower and Perot Museum of Nature and Science, to new experiences in must-see spots like Trinity Groves and the Design District. Throughout Dallas, you'll find plenty of ways to fill a one, two, or even three-day trip to Dallas with performances, restaurants, and adventures!`,
    WhyVisitImage: WhyDallas,
    ThingsToDo: [
      {
        ImgUrl: CowboysStadiun,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Dallas Cowboys Football Stadium Tour`,
        FrameText: `Visit the press box, locker rooms and  field on a VIP tour of AT&T Stadium.`
      },
      {
        ImgUrl: SouthforkRanch,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `SouthFork Ranch Experience`,
        FrameText: `Channel JR Ewing. A helicopter ride is followed by private tour and steak dinner at the ranch.`
      },
      {
        ImgUrl: ArtTour,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Dallas Art Tour`,
        FrameText: `Visit premiere museums and private art galleries in the Greater Dallas area with a contemporary arts guide.`
      },
      {
        ImgUrl: DayTour,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Full-day Tour of Dallas`,
        FrameText: `From award-winning architecture to JFK’s assassination site, your private guide will show you inside the Big D.`
      },
      {
        ImgUrl: PerotMuseum,
        LinkUrl: 'https://www.jetsuite.com',
        visible: 1,
        FrameHeader: `Perot Museum of Nature & Science`,
        FrameText: `Explore the dynamic Perot Museum with a private guide who will make your time spent educational.`
      }
    ],
    
    RecommendedLocales: [
      {
        ImgUrl: RosewoodMansion,
        LinkUrl: 'https://www.rosewoodhotels.com/en/mansion-on-turtle-creek-dallas',
        FrameHeader: `Rosewood Mansion on Turtle Creek`,
        FrameText: `Located in the heart of Dallas' most fashionable neighborhood, the hotel reflects the intimate ambiance of a private residence. Designed with all the comforts and conveniences of home.`
      },
      {
        ImgUrl: FourSeasonDallas,
        LinkUrl: 'https://www.fourseasons.com/dallas/',
        FrameHeader: `Four Seasons Dallas at Las Colinas`,
        FrameText: `Throw in some extra athletic gear and make use of the luxury resort’s par-70 TPC Las Colinas golf course, pools and lavish tennis and sports facilities. Rooms and suites have an extraordinary range of views.`
      },
      {
        ImgUrl: JouleDallas,
        LinkUrl: 'https://www.thejouledallas.com/',
        FrameHeader: `The Joule`,
        FrameText: `The Joule is named for the unit of energy and occupies a revitalized 1920's landmark building. The hotel creates a union of old world quality and contemporary design with a distinguished collection of original artwork.`
      }
    ]
  }
};







// WEBPACK FOOTER //
// ./src/components/ExperiencesLandingPage/LandingPageData.js